module.exports = __webpack_public_path__ + "static/media/downloadfilesvg.312142cd.svg";